var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFadersHorizontal = function SvgIconFadersHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 4.625a1 1 0 0 1 1 1v1.25h9.125a1 1 0 1 1 0 2h-9.125v1.25a1 1 0 1 1-2 0v-4.5a1 1 0 0 1 1-1M2.75 7.875a1 1 0 0 1 1-1h2.625a1 1 0 0 1 0 2H3.75a1 1 0 0 1-1-1M3.75 15.125a1 1 0 1 0 0 2h8.625a1 1 0 1 0 0-2zM15.125 13.875a1 1 0 1 1 2 0v1.25h3.125a1 1 0 1 1 0 2h-3.125v1.25a1 1 0 1 1-2 0z"
  }))));
};
export default SvgIconFadersHorizontal;